/**
 * Who sees BAM IQ's founder tools (D154): rating answers, notes, test cases
 * and reruns. Coleman's account only, by Supabase user id, on the server and
 * in the app (the app learns it from the server's overview, so it can't be
 * switched on in a browser). BAMIQ_FOUNDER_IDS replaces the list (comma or
 * space separated), for the local preview's synthetic account.
 *
 * Not a coach feature: there's no feedback system or dashboard for coaches.
 */
export const FOUNDER_IDS = ["9f1f4b1c-c46e-4178-b39c-f3210cba7f00"];

export function founderIds(env = {}) {
  const raw = String(env.BAMIQ_FOUNDER_IDS || "").trim();
  const list = raw ? raw.split(/[\s,]+/) : FOUNDER_IDS;
  return list.map(s => s.trim().toLowerCase()).filter(s => /^[0-9a-f-]{36}$/.test(s));
}

export const isFounder = (userId, env = {}) => !!userId && founderIds(env).includes(String(userId).toLowerCase());

/** A founder test case as the GitHub eval runner reads it (docs/bam-iq/evals/founder-cases/<id>.json). */
export function caseForEvals(c) {
  return {
    id: `F-${String(c.id).slice(0, 8)}`, quality: c.kind === "keep" ? "Founder keep case (regression)" : "Founder regression case", level: "Coleman's own question",
    turns: (c.turns || []).map(t => t.coach), expect: c.expect || "", forbidden: c.forbidden || "",
    kind: c.kind || "fix", capabilities: c.capabilities || [], behavior: c.behavior || "",
    original: { body: c.original?.body || "", model: c.original?.model || null, runtime: c.original?.runtime || null, effort: c.original?.effort || null },
    feedback: c.feedback || null, created_at: c.created_at || null,
  };
}

/**
 * Every reviewed case in full, for the training cycle's analysis (2026-10-25): the conversation, the answers and what
 * produced them (model, effort, sources found and cited, cost, time), his feedback, scores, safety checks and the
 * causes. Names are already [P1], [P2]... in every case.
 */
export function casesBundle(cases = []) {
  const slim = (a) => a && { body: a.body, model: a.model, effort: a.effort, runtime: a.runtime, kind: a.kind, depth: a.depth, cost_usd: a.cost_usd, timing: a.timing,
    refs: (a.refs || []).map(r => ({ tag: r.tag, key: r.key, type: r.type, title: r.title })), retrieved: a.retrieved || [], judgement: a.judgement || null,
    ...(a.checks ? { checks: a.checks } : {}), ...(a.version ? { version: a.version } : {}), ...(a.verdict ? { verdict: a.verdict } : {}), ...(a.at ? { at: a.at } : {}) };
  return { exported_at: new Date().toISOString(), cases: cases.filter(c => c.status === "reviewed").map(c => ({
    id: c.id, kind: c.kind || "fix", capabilities: c.capabilities || [], behavior: c.behavior || "", expect: c.expect || "", forbidden: c.forbidden || "",
    cause: c.cause || [], cause_note: c.cause_note || "", feedback: c.feedback ? { rating: c.feedback.rating, reasons: c.feedback.reasons || [], note: c.feedback.note || "" } : null,
    turns: c.turns || [], original: slim(c.original), runs: (c.runs || []).map(slim), plan_context: !!c.plan_context,
  })) };
}
